import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterListaNegraModel } from 'src/app/models/interfaces/listanegra/IFilterListaNegraModel';
import { IListaNegraModel } from 'src/app/models/interfaces/listanegra/IListaNegraModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ListanegraService {
  private configUrl = [environment.apiGatewayUrl, 'listanegra'].join('/');

  constructor(private http: HttpClient) {}

  getListPaged(
    model: IFilterListaNegraModel
  ): Observable<SearchResultModel<IListaNegraModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);

    if (model.nombres !== '') {
      queryParams.push(`nombres=${model.nombres}`);
    }

    if (model.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${model.nroDocumento}`);
    }

    if(model.idsListaNegra.length > 0){
      queryParams.push(`ids=${model.idsListaNegra.join(',')}`);
    }
    if(model.companias.length > 0){
      queryParams.push(`companias=${model.companias.join(',')}`);
    }

    return this.http.get<SearchResultModel<IListaNegraModel[]>>(
      this.configUrl + '?'+ queryParams.join('&')
      );
  }

  submit(model: IListaNegraModel) {
    return this.http.post<ActionResultModel>(`${this.configUrl}`, model);
  }

  delete(id: number) {
    return this.http.delete<ActionResultModel>(`${this.configUrl}/${id}`);
  }
}
